import { getPhoneCountry, normalizeNationalNumber, parseInternationalPaste, phoneCountries } from "./phone-codes";

export const contactSubjects = [
  "Role or career opportunities",
  "Advisory",
  "Speaking or media",
  "Product collaboration",
  "Website feedback",
  "Report a bug",
  "Submit a feature request",
  "Privacy request",
  "Other",
] as const;

export function contactPrefill(params: URLSearchParams) {
  const subject = params.get("subject")?.trim().toLowerCase() ?? "";
  const requestedCountry = (params.get("countryCode") ?? "").trim().toUpperCase();
  const explicitCountry = phoneCountries.find((country) => country.code === requestedCountry)
    ?? phoneCountries.find((country) => country.dialCode === requestedCountry.replace(/^\+|^00/, ""));
  const phone = (params.get("phone") ?? "").trim();
  const international = /^(\+|00)/.test(phone) ? parseInternationalPaste(phone) : undefined;
  // Preserve an explicit country for shared calling codes (for example Canada +1).
  const parsedCountry = international?.countryCode ? getPhoneCountry(international.countryCode) : undefined;
  const countryCode = parsedCountry && parsedCountry.dialCode !== explicitCountry?.dialCode
    ? parsedCountry.code : explicitCountry?.code ?? parsedCountry?.code;
  return {
    name: (params.get("name") ?? "").slice(0, 100),
    email: (params.get("email") ?? "").slice(0, 254),
    company: (params.get("company") ?? "").slice(0, 120),
    subject: contactSubjects.find((option) => option.toLowerCase() === subject || option.toLowerCase().replace(/[^a-z0-9]+/g, "-") === subject) ?? "",
    message: (params.get("message") ?? "").slice(0, 4000),
    countryCode,
    nationalNumber: international?.nationalNumber ?? normalizeNationalNumber(phone),
  };
}
